import { render, staticRenderFns } from "./BroadcastCard.vue?vue&type=template&id=3a20dcb2&scoped=true&"
import script from "./BroadcastCard.vue?vue&type=script&lang=js&"
export * from "./BroadcastCard.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastCard.vue?vue&type=style&index=0&id=3a20dcb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20dcb2",
  null
  
)

export default component.exports